import { Grid, Button } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useHint } from 'v2/components/Shared/Hint';
import { EHintPath } from 'v2/interfaces/hint';

import { ProvideEditProduct, useEditProduct } from './context';
import Digital from './Digital';

const useStyle = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  title: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#192542',
    '& h1': {
      fontSize: '2rem',
      lineHeight: 1,
      fontWeight: 400,
      marginBottom: '0.5rem',
    },
    '& p': {
      fontSize: '1rem',
      lineHeight: '1.3125rem',
      color: '#818b9d',
    },
  },
}));

function NewEditProduct(props: any) {
  const { id } = props.match.params;
  const { isLoading, product, loadProduct } = useEditProduct();
  const classes = useStyle(props);

  useHint(EHintPath.PRODUCT);

  useEffect(() => {
    if ((id && !product) || (id && product.id !== Number(id))) loadProduct(id);
  }, [id, loadProduct, product]);

  if (!product || isLoading) {
    return <Spin />;
  }

  return (
    <MuiThemeProvider theme={theme}>
      <div className={classes.title}>
        <div>
          <h1>{product.title}</h1>
          <p>Edite aqui todas as particularidades do seu produto.</p>
        </div>
        <Button variant='contained' color='primary'>
          Criar Variações
        </Button>
      </div>
      <div className='m32' />
      <Grid className={classes.root} container spacing={2}>
        <Grid item xs={12}>
          <Digital />
        </Grid>
      </Grid>
    </MuiThemeProvider>
  );
}

const EditProduct = NewEditProduct;

function Provide(props: any) {
  return (
    <ProvideEditProduct>
      <EditProduct {...props} />
    </ProvideEditProduct>
  );
}

export default withRouter(Provide);
